module.exports = __webpack_public_path__ + "media/images/writer/home/kv-bg-desktop-2ae52154dd97d91cacc57a020ff0a469.png";